import getCurrentYear from './current-year';

const getPreviousYear = () => getCurrentYear() - 1;

export default getPreviousYear;
